import ButtonContainer from "@components/ButtonContainer";
import TextEditorTwo from "@components/EasyDev/text-editor/TextEditor";
import FormTextField from "@components/Shared/FormTextField";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";
import styles from "./CreateForm.module.scss";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => (
  <form
    className={`${styles.createForm} form form--horizontal`}
    onSubmit={handleSubmit}
  >
    <div className="form__form-group">
      <span className="form__form-group-label">Question</span>
      <div className="form__form-group-field">
        <Field
          name="question"
          component={FormTextField}
          type="text"
          placeholder={"Enter a Question"}
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Answer</span>
      <div className="form__form-group-field">
        <Field name="answer" component={TextEditorTwo} isAboveError />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Order</span>
      <div className="form__form-group-field">
        <Field
          name="order"
          component={FormTextField}
          type="number"
          placeholder={"Enter Order"}
          isAboveError
        />
      </div>
    </div>

    <ButtonContainer />
  </form>
);

export default CreateForm;
